import React from 'react';

import styled from 'styled-components';

type IToggleContainer = {
  checked: boolean;
  disabled: boolean;
};

interface IToggle {
  checked: boolean;
  disabled?: boolean;
  [key: string]: any;
}

const Slider = styled.div`
  &::before {
    position: absolute;
    content: '';
    height: 28px;
    width: 28px;
    left: 1px;
    bottom: 1px;
    border-radius: 50%;
    background-color: ${Styles.color.white};
    pointer-events: none;
    transition: 0.2s ease-out transform;
  }
`;

const ToggleContainer = styled.div<IToggleContainer>`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 30px;
  border-radius: 50px;
  background-color: ${p => {
    if (p.disabled) {
      return p.checked ? '#E54861' : '#979797';
    }
    return p.checked ? Styles.color.primary : Styles.color.grey.one;
  }};

  & > ${Slider}::before {
    transform: translateX(${p => (p.checked ? 20 : 0)}px);
  }
`;

const HiddenInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;

  &[disabled] {
    cursor: not-allowed;
  }
`;

const Toggle: React.FC<IToggle> = ({ checked, disabled = false, ...props }) => (
  <ToggleContainer checked={checked} disabled={disabled}>
    <HiddenInput
      type="checkbox"
      role="button"
      aria-pressed={checked}
      disabled={disabled}
      {...props}
    />
    <Slider />
  </ToggleContainer>
);

export default Toggle;
